import { ScheduleSendOutlined } from "@mui/icons-material";
import { DateTime } from "luxon";
import { ItemProperty } from "src/components";

interface Props {
  submittedDateTimeUtc: string;
}

const FormSubmissionSubmittedProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<ScheduleSendOutlined />} label="Submitted">
      {DateTime.fromISO(props.submittedDateTimeUtc, { zone: "utc" }).toLocal().toLocaleString(DateTime.DATE_MED)}
    </ItemProperty>
  );
};

export { FormSubmissionSubmittedProperty };
